module.exports = __webpack_public_path__ + "static/media/M1-28-Nector-Sadjin-cod147.af948d96.png";